import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ActivitiesCard from './ActivitiesCard'
import SidebarWidgets from '../Common/SidebarWidgets'
import { api } from '../../services/api'
import { useContentList } from '../../hooks/useContent'

function ActivitiesInner() {
    const { items: posts, loading, error } = useContentList(() => api.getActivities({ per_page: 100 }), [])
    const [currentPage, setCurrentPage] = useState(1)
    const postsPerPage = 8

    const totalPages = Math.ceil(posts.length / postsPerPage) || 1
    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost)

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    if (!loading && !error && !posts.length) {
        return null
    }

    return (
        <section className="space">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        {loading && <p className="text-center">Loading activities...</p>}
                        {error && <p className="text-center text-danger">{error}</p>}
                        <div className="row gy-24 gx-24">
                            {currentPosts.map((data) => (
                                <div key={data.id} className="col-md-6">
                                    <ActivitiesCard
                                        activitiesID={data.id}
                                        activitiesImage={`${data.image}`}
                                        activitiesTitle={data.title}
                                        activitiesPrice={data.price}
                                    />
                                </div>
                            ))}
                            {posts.length > postsPerPage && (
                                <div className="th-pagination text-center mt-60 mb-0">
                                    <ul>
                                        {Array.from({ length: totalPages }, (_, i) => (
                                            <li key={i}>
                                                <Link
                                                    className={currentPage === i + 1 ? 'active' : ''}
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        handlePageChange(i + 1)
                                                    }}
                                                >
                                                    {i + 1}
                                                </Link>
                                            </li>
                                        ))}
                                        {currentPage < totalPages && (
                                            <li>
                                                <Link
                                                    className="next-page"
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        handlePageChange(currentPage + 1)
                                                    }}
                                                >
                                                    Next <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <SidebarWidgets categoryType="tour" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ActivitiesInner
